import type { ReactNode } from "react";

type PageTitleBarProps = {
  title: ReactNode;
  subtitle?: string;
  rightContent?: ReactNode;
};

export default function PageTitleBar({ title, subtitle, rightContent }: PageTitleBarProps) {
  return (
    <div className="relative z-30 overflow-visible rounded-2xl border border-cyan-200/70 bg-gradient-to-r from-cyan-50 via-white to-teal-50 p-5 shadow-sm dark:border-cyan-900/40 dark:from-cyan-950/40 dark:via-gray-900 dark:to-teal-950/30">
      <div className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-cyan-400/20 blur-2xl" />
      <div className="pointer-events-none absolute -bottom-12 left-12 h-24 w-24 rounded-full bg-teal-400/20 blur-2xl" />

      <div className="relative flex min-w-0 flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 flex-1">
          <h1 className="text-xl font-semibold tracking-tight text-cyan-950 dark:text-cyan-100 md:text-2xl">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-1 text-sm text-cyan-800/80 dark:text-cyan-200/80">
              {subtitle}
            </p>
          ) : null}
        </div>
        {rightContent ? <div className="shrink-0">{rightContent}</div> : null}
      </div>
    </div>
  );
}
